import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRightOutlined,
  HomeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./App.css";

/**
 * 首页服务入口
 *
 * 首页只负责展示「服务」，
 * 不在这里展示服务内部的具体功能。
 *
 * 后续增加服务时，继续在这里添加即可。
 */
const services = [
  {
    key: "host",
    title: "房产",
    description: "房产相关服务",
    icon: <HomeOutlined />,
    path: "/host",
  },

  // 示例：
  //
  // {
  //   key: "finance",
  //   title: "财务",
  //   description: "财务相关服务",
  //   icon: <AccountBookOutlined />,
  //   path: "/finance",
  // },
];

function App() {
  const [user, setUser] = useState(null);

  /**
   * 首页只读取本地已经保存的用户信息。
   *
   * 登录态的真正校验由现有 Auth 组件及后端 /me 负责，
   * 首页这里只用于显示右上角的用户信息。
   */
  useEffect(() => {
    const userData = localStorage.getItem("user");

    if (!userData) {
      setUser(null);
      return;
    }

    try {
      const parsedUser = JSON.parse(userData);

      setUser(parsedUser);
    } catch (error) {
      console.error("读取用户信息失败:", error);

      localStorage.removeItem("user");

      setUser(null);
    }
  }, []);

  /**
   * 优先显示 name。
   * 如果 name 没有值，则显示 username。
   */
  const userName = user?.name || user?.username;

  return (
    <div className="home-page">
      {/* =========================
          顶部
      ========================== */}
      <header className="home-header">
        <Link to="/" className="home-brand">
          <div className="home-logo">爱</div>

          <div className="home-brand-text">
            <div className="home-brand-title">在磨丁</div>

            <div className="home-brand-subtitle">PROPERTY & SERVICE</div>
          </div>
        </Link>

        {/* =========================
            用户入口
        ========================== */}
        {user ? (
          <Link to="/profile" className="home-user">
            <UserOutlined />

            <span className="home-user-name">{userName}</span>
          </Link>
        ) : (
          <Link to="/login" className="home-login">
            登录
          </Link>
        )}
      </header>

      {/* =========================
          首页主体
      ========================== */}
      <main className="home-content">
        {/* 欢迎语 */}
        <section className="home-intro">
          <div className="home-eyebrow">WELCOME TO MOUDING</div>

          <h1>欢迎来到磨丁</h1>

          <p>选择您需要的服务</p>
        </section>

        {/* =========================
            服务入口
        ========================== */}
        <section className="service-grid">
          {services.map((service) => (
            <Link key={service.key} to={service.path} className="service-card">
              <div className="service-card-top">
                <div className="service-icon">{service.icon}</div>

                <ArrowRightOutlined className="service-arrow" />
              </div>

              <div className="service-info">
                <h2>{service.title}</h2>

                <p>{service.description}</p>
              </div>
            </Link>
          ))}
        </section>
      </main>

      {/* =========================
          页脚
      ========================== */}
      <footer className="home-footer">
        <span>© 2026 在磨丁</span>
      </footer>
    </div>
  );
}

export default App;
